<template>
  <q-section v-bind="$attrs" :pt="statusBarHeight" @click="back"></q-section>
</template>

<script setup lang="ts">
import { requestApp } from '@/core/bridge'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

// 状态栏安全区基础上再下移 20（设计稿 px，与 q-section pt 一致）
const STATUS_BAR_FALLBACK = 27
const EXTRA_BELOW_STATUS_BAR = 20
const statusBarHeight = ref(STATUS_BAR_FALLBACK + EXTRA_BELOW_STATUS_BAR)
onMounted(async () => {
  try {
    const h = await requestApp('ucoo_status_bar_height')
    const base = Number(h)
    statusBarHeight.value = (Number.isFinite(base) && base > 0 ? base : STATUS_BAR_FALLBACK) + EXTRA_BELOW_STATUS_BAR
  } catch (e) {
    console.log(e)
  }
})
const back = () => {
  // 判断路由栈长度
  if (router.options.history.state.back) {
    router.back()
  } else {
    requestApp('ucoo_finish')
  }
}
</script>

<style scoped lang="scss"></style>
